'use client';

import { c as _c } from "react/compiler-runtime";
import { getApiUrl } from '@/config/constants';
import { useState, useEffect } from 'react';
export function DevBanner() {
  const $ = _c(5);
  const [isDismissed, setIsDismissed] = useState(false);
  const [apiUrl, setApiUrl] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined") {
        setApiUrl(getApiUrl(window.location.origin));
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (process.env.NODE_ENV !== "development" || process.env.NEXT_PUBLIC_ENV !== "development" || isDismissed) {
    return null;
  }
  const dbName = process.env.NEXT_PUBLIC_DEV_DB_NAME || "default";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button onClick={() => setIsDismissed(true)} className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full p-1 transition-colors hover:bg-yellow-200" aria-label="Dismiss banner">✕</button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== apiUrl) {
    t3 = <div className="sticky top-0 z-50 w-full border-b border-yellow-200 bg-yellow-100 px-4 py-2 text-center text-sm text-yellow-800">⚠️ Development Environment - DB name:{dbName}, API root: {apiUrl}{t2}</div>;
    $[3] = apiUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}